<template>
  <div id="first-price">

    <!-- 首本优惠提示 -->
    <div class="hottest-memo" v-if="order.first_order_reduce">
      <span>此价格已享受首本优惠价，此优惠每个商户限享受一次</span>
    </div>
  </div>
</template>

<script>
import dateUtils from '../../../libs/date-util';

export default {
  name: 'first-price',
  props: {

    // 订单信息
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    formatDateWithoutYear: dateUtils.formatDateWithoutYear,
  },
};
</script>

<style lang="less" scoped>
#first-price {
  .hottest-memo {
    height: 40px;
    background-color: #ffffc5;
    width: 100%;
    padding: 0 30px 0 30px;
    color: #fc7906;
    font-size: 14px;
    text-align: left;
    line-height: 40px;
    .hottest-memo-price {
      font-size: 18px;
      font-weight: 700;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/first-price.vue